import { Flex } from '@mantine/core';
import { Text } from '@repo/foundations';
import { useStyles } from './styles';

export function ViolationTableTitle({
	showScoreColumn,
	dataScanning,
}: {
	showScoreColumn: boolean;
	dataScanning?: boolean;
}) {
	const { classes } = useStyles();
	return (
		<Flex p={0}>
			<Text pl="xs" className={classes.resourceColumn}>
				Resources at risk
			</Text>
			{dataScanning && (
				<Text className={classes.statusColumn}>Issue Status</Text>
			)}
			<Text className={classes.conditionsColumn}>Conditions not met</Text>
			{showScoreColumn && (
				<Text className={classes.scoreColumn}>Score impact</Text>
			)}
			<Text className={classes.dateColumn}>Issue occurred</Text>
		</Flex>
	);
}
